import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "./../../environments/environment";

import moment from "moment";
import { AngularFirestore } from "@angular/fire/compat/firestore";

@Injectable({
  providedIn: "root",
})
export class FirestoreService {
  domain = "https://datastore.orionintelligentenergy.com:9331/";
  // cloudFuncUrl = environment.cloudFunctionUrl;
  cloudFuncUrl = environment.cloudFunctionUrl;
  analyticsUrl =
    "https://asia-south1-las-prod-1.cloudfunctions.net/PredictAI_JSPL/getAnalyticsData";
  httpHeaders: any;
  options: any = {};
  getDataUrl: string = this.cloudFuncUrl + "getData";
  getHistoryDataUrl: string = this.cloudFuncUrl + "getHistoryData";
  updateDataUrl: string = this.cloudFuncUrl + "updateData";
  deleteDataUrl: string = this.cloudFuncUrl + "deleteData";
  insertDataUrl: string = this.cloudFuncUrl + "insertData";
  customerId: string = "VECV";
  localApiurl = environment.api_endpoint;
  constructor(private http: HttpClient, private db: AngularFirestore) {
    this.httpHeaders = new HttpHeaders();
    this.httpHeaders.set("Content-Type", "application/json");
  }

  updateAssetTime() {
    return this.http.post(
      "https://asia-south1-las-prod-1.cloudfunctions.net/PredictAI_JSPL/updateTimestampInAsset",
      {},
      this.httpHeaders
    );
  }
  sendMailAlert(params) {
    return this.http.post(
      "https://asia-south1-etp-paint-shop.cloudfunctions.net/sendmail",
      params,
      this.httpHeaders
    );
  }
  fireStoreDocInsert(category: string, data: any) {
    let insertData = { data: data, category: category };
    return this.http.post(this.insertDataUrl, insertData, this.httpHeaders);
  }
  addInjuryData(formData) {
    return this.http.post(
      "https://asia-south1-etp-paint-shop.cloudfunctions.net/vecv-paint-shop/saveInjuryDetails",
      formData,
      this.httpHeaders
    );
  }
  fireStoreDocUpdate(category: string, id, data: any) {
    let updateData = { id: id, data: data, category: category };
    return this.http.post(this.updateDataUrl, updateData, this.httpHeaders);
  }
  fireStoreDocDelete(category: string, id) {
    let deleteData = { id: id, category: category };
    return this.http.post(this.deleteDataUrl, deleteData, this.httpHeaders);
  }
  passwordUpdate(updateData: any) {
    return this.http.post(
      "https://asia-south1-etp-paint-shop.cloudfunctions.net/Authenticate/updatePassword",
      updateData,
      this.httpHeaders
    );
  }
  createUser(data: any) {
    //  data.customerId = this.customerId;
    data.clientId = this.customerId;
    return this.http.post(
      "https://asia-south1-etp-paint-shop.cloudfunctions.net/Authenticate/createuser",
      data,
      this.httpHeaders
    );
  }
  getData(params: any) {
    if (params.category && params.category === "HISTORY") {
      // if (params.aggregation && (params.aggregation == "Live" || params.aggregation === "localHistory")) {
      //   params.collection = "HistoryData";
      //   return this.http.post(`${this.localApiurl}api/history/get`, params, this.httpHeaders);
      // }
      if (
        params.aggregation &&
        (params.aggregation == "Aggregate10MinuiteData" ||
          params.aggregation == "Aggregate60MinuiteData" ||
          params.aggregation == "Aggregate1440MinuiteData")
      ) {
        if (params.conditions && params.conditions.length > 0) {
          params.conditions = JSON.stringify(params.conditions);
        }
        return this.http.post(this.getDataUrl, params, this.httpHeaders);
      } else {
        /* Bigtable query code here*/
        let data = {
          customerId: "BLP",
          assetcode: params.assetcode,
          asset: params.asset,
          aggregateFrame: params.aggregateFrame,
          startTime: moment(params.startDate).unix(),
          endTime: moment(params.endDate).unix(),
        };
        return this.http.post(this.domain + "api/bigtable/select", data, {
          headers: this.httpHeaders,
        });
      }
    } else {
      if (params.conditions && params.conditions.length > 0) {
        params.conditions = JSON.stringify(params.conditions);
      } else if (params.conditions && params.conditions.length == 0) {
        delete params.conditions;
      }
      return this.http.post(this.getDataUrl, params, this.httpHeaders);
    }
  }
  getAnalyticsData(params) {
    return this.http.post(this.analyticsUrl, params, this.httpHeaders);
  }
  saveWidgetOrder(params) {
    return this.http.post(
      this.cloudFuncUrl + "saveWidgetOrder",
      params,
      this.httpHeaders
    );
  }
  saveEquipment(data: any) {
    return this.http.post(
      this.cloudFuncUrl + "saveEquipment",
      data,
      this.httpHeaders
    );
  }
  deleteEquipment(data: any) {
    return this.http.post(
      this.cloudFuncUrl + "deleteEquipment",
      data,
      this.httpHeaders
    );
  }

  // Vecv Calls
  getLiveData(params) {
    return this.db.collection(params.collection).valueChanges();
  }
  getZoneData(params) {
    return this.db
      .collection(params.collection)
      .doc(params.docId)
      .valueChanges();
  }
  getShiftwiseproduction(params) {
    return this.db
      .collection(params.collection)
      .doc(params.docId)
      .valueChanges();
  }
  getHistoryData(params) {
    let c = `/DATA/VECV/HISTORYKPI/${params.zone}/${params.shift}`;
    return this.db
      .collection(c, (ref) =>
        ref
          .where("date", ">=", params.startDate)
          .where("date", "<=", params.endDate)
      )
      .get();
  }
  updateDoc(collection: string, id: string, data) {
    return this.db.collection(collection).doc(id).update(data);
  }
  getAggregationData(params) {
    return this.db
      .collection(
        `/DATA/VECV/AGGREGATE_RAWDATA/${params.aggregationType}/${params.asset}`,
        (ref) =>
          ref
            .where("timestamp", ">=", params.startDate)
            .where("timestamp", "<=", params.endDate)
      )
      .get();
  }
  getSustainabilityData() {
    return this.db
      .collection("/DATA/VECV/sustainability/", (ref) =>
        ref.orderBy("timestamp", "desc").limit(1)
      )
      .valueChanges();
  }
  getTillDateLTI() {
    return this.db
      .collection("/DATA/VECV/Injurydetails", (ref) =>
        ref
          .orderBy("admission_date", "desc")
          .where("injury_type", "==", "Loss Time Injury")
          .limit(1)
      )
      .valueChanges();
  }
  getAlertsData(params) {
    return this.db
      .collection(`/DATA/VECV/Alerts/`, (ref) =>
        ref
          .where("asset", "==", params.asset)
          .orderBy("timestamp", "desc")
          .where("timestamp", ">=", params.startDate)
          .where("timestamp", "<=", params.endDate)
      )
      .get();
  }
  getSafetyTags(params) {
    return this.db
      .collection("/DATA/VECV/LIVEKPI/")
      .doc(params.id)
      .valueChanges();
  }
  getHistorySafetyTags(params) {
    return this.db
      .collection(`/DATA/VECV/HISTORYKPI/${params.id}/${params.shift}`, (ref) =>
        ref
          .where("date", ">=", params.startDate)
          .where("date", "<=", params.endDate)
      )
      .get();
  }
  addDummyData(data) {
    return this.db.collection("/DATA/VECV/Henrich-Pyramid").add(data);
  }
  getPyramidData() {
    return this.db.collection("/DATA/VECV/Henrich-Pyramid").get();
  }
  updateHenrichPyramidData(id, data) {
    return this.db
      .collection("/DATA/VECV/Henrich-Pyramid")
      .doc(id)
      .update(data);
  }
  insertHenrichPyramidData(data) {
    return this.db.collection("/DATA/VECV/Henrich-Pyramid").add(data);
  }
  tempViscosity() {
    return this.db.collection("/DATA/VECV/LiveData",ref =>
    ref.where('asset',"==","Paint Mixing Room")).valueChanges();
    // ,ref =>
    // ref.where("asset", "==", "PMR")
    // .where("tag", "==", "Temperature Actual Value").valueChanges();
  }
  // getHourlyData(params){
  //   return this.db.collection(`/DATA/VECV/AGGREGATE_KPIDATA/60minutes/${params.shift}`,ref =>
  //     ref.where('date','>=',params.startDate).where('date','<=',params.endDate)).valueChanges()
  // }
  getHourlyData(params){
      return this.db.collection(`/DATA/VECV/hourly_Production/${params.zone}/${params.shift}`,ref =>
        ref.where('timestamp','==',params.startDate)).valueChanges()
    }
  getCbmData(){
    return this.db.collection('/DATA/VECV/CBM').get()
  }
  // getPmData(params){
  //   return this.db.collection('/DATA/VECV/Maintenance',ref =>
  //   ref.where('type', "==",'pm').where('plannedDate','>=',params.startDate)
  //   .where('plannedDate','<=',params.endDate)).get()
  // }
    getPmData(params){
    return this.db.collection('/DATA/VECV/PM',ref =>ref.where('plannedDate','>=',params.startDate)
    .where('plannedDate','<=',params.endDate)).get()
  }
  // getTbmData(params){
  //   return this.db.collection('/DATA/VECV/Maintenance',ref =>
  //     ref.where('type', "==",'tbm').where('status','==',params.status).where('plannedDate','>=',params.startDate)
  //     .where('plannedDate','<=',params.endDate)).get()
  // }
  getTbmData(params){
    return this.db.collection('/DATA/VECV/TBM',ref =>ref.where('plannedDate','>=',params.startDate)
        .where('plannedDate','<=',params.endDate)).get()
  }
  getDefectsData(params) {
    if(params.shift != 'all'){
      return this.db.collection("/DATA/VECV/quality_defects_mobile", ref =>
      ref
        .where("defectCapturedTime", ">=", params.startDate)
        .where("defectCapturedTime", "<=", params.endDate)
        .orderBy("defectCapturedTime", "desc").where('shift',"==",params.shift)
    ).valueChanges()
    }else{
      return this.db
        .collection("/DATA/VECV/quality_defects_mobile", (ref) =>
          ref
            .where("defectCapturedTime", ">=", params.startDate)
            .where("defectCapturedTime", "<=", params.endDate)
            .orderBy("defectCapturedTime", "desc")
        )
        .valueChanges();
    }

    // if(params.shift != 'all'){
    //   doc.ref.where('shift','==',params.shift)
    // }
  }
  getOnlineProcessReliability(params?){
    return this.db.collection('/DATA/VECV/Process_Reliability/Reliability/Online_Reliability', ref =>
      ref.orderBy('timestamp','desc').limit(1)).valueChanges()
  }
  getOnlineCbmProcessReliability(params?){
    return this.db.collection('/DATA/VECV/Process_Reliability/Reliability/Cbm_Online', ref =>
    ref.orderBy('timestamp','desc').limit(1)).valueChanges()
    }
  getOfflineProcessReliability(params?){
   if(!params){
    return this.db.collection('/DATA/VECV/Process_Reliability/Reliability/Offline_Reliability', ref =>
      ref.orderBy('timestamp','desc').limit(1)).valueChanges()
   }
   else{
    return this.db.collection('/DATA/VECV/Process_Reliability/Reliability/Offline_Reliability', ref =>
    ref.orderBy('timestamp','desc').where('timestamp','>=',params.startDate).where('timestamp','<=',params.endDate)).valueChanges()
   }
  }
  getBreakdownData(params){
    return this.db.collection("/DATA/VECV/Maintenance/", ref =>
      ref.where('status',"==",params.status).where('type', "==","breakdown").where('targetDate','>=',params.startDate).where('targetDate','<=',params.endDate)).get()
  }
  updateCapaStatus(id,value){
    return this.db.collection("/DATA/VECV/Maintenance/").doc(id).update(value)
  }
  userValidation(data){
    if(data==='userEmail'){
       return this.db.collection('/DATA/VECV/Users').get()
    }
else{
    return this.db.collection('/DATA/VECV/Users',ref=>
    ref.where('email','==',data)
    ).get()
  }
}
  getAlertCount(){
    let startDate=moment().startOf('day').toDate()
    let lastThreeDateDatas=moment(startDate).subtract('3','days').toDate()
    return this.db.collection('/DATA/VECV/Alerts',(ref)=>
    //ref.where('timestamp','>=',lastThreeDateDatas).where('timestamp','<=',startDate)
    ref.orderBy('timestamp','desc').where('timestamp','>=',startDate)
    ).valueChanges()
  }
  /* User Page MAIL start */
  getRequestOTPUser(data) {
    return this.http.post(
      `/Email-Verification/generateOTP`,
      data,
      {
        headers: new HttpHeaders({
          "content-type": "application/json",
          "Authorization": "Basic " + btoa('otpservice@blpadmin.co.in:Sjq73cdd5SAhs'),
        })
      }
    );
  }
  verifyUserMAilOTP(data) {
    return this.http.post(
      `/Email-Verification/verifyOTP`,
      data,
      {
        headers: new HttpHeaders({
          "content-type": "application/json",
          "Authorization": "Basic " + btoa('otpservice@blpadmin.co.in:Sjq73cdd5SAhs'),
        })
      }
    );
  }
 sendProductionMail(body){
  return this.http.post(`https://asia-south1-etp-paint-shop.cloudfunctions.net/vecv-paint-shop/productionReport`,
  body)
 }
 getDownTimeData(params?){
  if(params.collection=='Monthly_DowntimeData'){
  return this.db.collection(`/DATA/VECV/${params.collection}`,(ref)=> ref.where('timestamp','==',params.startDate)).valueChanges()
 }
 else{
  return this.db.collection(`/DATA/VECV/${params.collection}`,(ref)=> ref.where('startYear','==',params.startDate).where('endYear','==',params.endDate)).valueChanges()
 }
}
updateMaintenance(id,data){
  return this.db.collection(`/DATA/VECV/Maintenance`).doc(id).update({remarks:data['remarks']})
}
getDefectsDetailData(data){
  return this.db.collection("/DATA/VECV/quality_defects_mobile", ref =>
  ref .where("CabinNO", "==", data)//A0072573)
).get()
}
getLastmaintenace(params){
  return this.db.collection("/DATA/VECV/Maintenance/", ref =>
    ref.where('type', "==",params['type']).where('equipmentId','==',params.equipmentId).where('activityName','==',params.activityName).orderBy('maintenanceDate','desc')).get()
}
//Defect-Analysis
getDefectAnalysisData(params) {
    return this.db
      .collection("/DATA/VECV/quality_defects_mobile", (ref) =>
        ref
          .where("defectCapturedTime", ">=", params.startDate)
          .where("defectCapturedTime", "<=", params.endDate)
          .orderBy("defectCapturedTime", "desc")
      )
      .valueChanges();
    // return this.db.collection("/DATA/VECV/test_quality_defects_mobile").get()
    // return this.db
    // .collection("/DATA/VECV/test_quality_defects_mobile", (ref) =>
    //   ref.orderBy("defectCapturedTime", "desc")
    // )
    // .valueChanges();
}
getShiftwiseDefectAnalysisData(params) {
  return this.db
    .collection("/DATA/VECV/quality_defects_mobile", (ref) =>
      ref
        .where("defectCapturedTime", ">=", params.startDate)
        .where("defectCapturedTime", "<=", params.endDate)
        .orderBy("defectCapturedTime", "desc").where('shift',"==",params.shift)
    )
    .valueChanges();
}
}
